<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>
									ตัวแทนขาย
								</span>
							</div>
							<div class="search-filter">
								<h1>
									ตัวแทนขาย
								</h1>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<div class="bgDarkGrey">
			<v-container class="pa-0">
				<v-row>
					<v-col
						cols="12"
						lg="11"
						xl="8"
						class="mx-auto py-0"
					>
						<v-card
							color="transparent"
							style="margin-top: -52px;"
							tile
							flat
						>
							<v-btn-toggle
								borderless
								light
								mandatory
								tile
							>
								<v-btn
									class="flex-grow-1 flex-md-grow-0"
									x-large
								>
									ค้นหาตัวแทนขาย
								</v-btn>
							</v-btn-toggle>
							<div>
								<div class="search white--text pa-8 pb-12">
									<v-row>
										<v-col
											cols="12"
											md="4"
											class="py-1"
										>
											<label><b>คำค้นหา</b></label>
											<client-only>
												<v-combobox
													v-model="agentQueryText"
													:items="agentAcItems"
													:loading="agentAcLoading"
													:search-input.sync="agentText"
													:menu-props="{ maxWidth: 570 }"
													:title="agentText"
													append-icon=""
													background-color="#fff"
													hide-details
													flat
													no-filter
													outlined
													color="red"
													height="36"
													class="textSearch"
													placeholder="ค้นหาตัวแทน"
													item-text="name"
													item-value="name"
													@keydown.native="agentQueryText = agentText"
													@focus="acQuery(agentText)"
												>
													<!-- eslint-disable -->
													<template v-slot:item="{parent, item}">
														<template v-if="typeof item !== 'object'">
															<v-list-item-content v-text="item" />
														</template>
														<template v-else>
															<v-list-item-content>
																<v-list-item-title v-html="filteredText(parent.searchInput, item.name)" />
																<v-list-item-subtitle v-html="filteredText(parent.searchInput, item.description)" />
															</v-list-item-content>
															<v-list-item-action>{{ item.category }}</v-list-item-action>
														</template>
													</template>
													<!-- eslint-enable -->
												</v-combobox>
											</client-only>
										</v-col>

										<v-col
											cols="12"
											md="3"
											class="py-1"
										>
											<label><b>จังหวัด</b></label>
											<client-only>
												<v-select
													v-model="provinceSelected"
													:items="location"
													:menu-props="{ maxHeight: '400' }"
													item-text="n"
													item-value="p"
													placeholder="เลือกจังหวัด"
													background-color="#fff"
													hide-details
													clearable
													flat
													return-object
													outlined
												/>
											</client-only>
										</v-col>

										<v-col
											cols="12"
											md="3"
											class="py-1"
										>
											<label><b>เขต/อำเภอ</b></label>
											<client-only>
												<v-select
													v-model="districtSelected"
													:disabled="disabledDistrict"
													:items="district"
													:menu-props="{ maxHeight: '400' }"
													item-text="n"
													item-value="d"
													placeholder="เลือกเขต/อำเภอ"
													background-color="#fff"
													hide-details
													clearable
													flat
													multiple
													outlined
												>
													<template v-slot:selection="{ item, index }">
														<span v-if="index === 0">{{ item.n }} </span>
														<span
															v-if="index === 1"
															class="grey--text caption ml-1"
														>
															(+{{ districtSelected.length - 1 }} เขต/อำเภอ)
														</span>
													</template>
												</v-select>
											</client-only>
										</v-col>

										<v-col
											cols="12"
											md="2"
											class="d-flex align-end py-1"
										>
											<v-btn
												class="btn-red-gradient white--text flex-grow-1"
												height="55"
												depressed
												tile
												@click="processParamsAndSearch();"
											>
												ค้นหา
											</v-btn>
											<v-btn
												class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
												height="56"
												depressed
												tile
												@click="processParamsAndSearch();"
											>
												<v-icon>
													mdi-arrow-right
												</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="agent-of-the-month justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2 class="text-center my-7">
							ตัวแทนขายดีเด่น<span class="red--text">เดือน {{ month }}</span>
						</h2>

						<client-only>
							<agentCarousel
								white
								:items="topAgentList"
								style="margin-bottom: 60px;"
							/>
						</client-only>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						ref="topList"
						xl="8"
						class="mx-auto"
					>
						<v-row>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>ตัวแทนขายทั้งหมด</h2>
								<span class="red--text">{{ total }} คน</span>
							</v-col>
							<v-col
								v-for="(agent, i) in loading ? parseInt(perPage) : agentList"
								:key="agent.id || i"
								cols="12"
								sm="6"
								md="3"
							>
								<agentListItemSkeleton v-if="loading" />
								<agentListItem
									v-else
									:agent="agent"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ total }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'agent'

import { mapActions, mapGetters } from 'vuex'
import agentListItem from '~/components/2.0/agent-list-item'
import agentListItemSkeleton from '~/components/2.0/agent-list-item-skeleton'
import agentCarousel from '~/components/2.0/agent-carousel'

export default {
	// scrollToTop: true,
	name: 'AGENT',
	layout: 'default_2',

	components: {
		agentListItem,
		agentListItemSkeleton,
		agentCarousel
	},

	async fetch(context) {
		await context.store.dispatch('page/initial', {
			doc: doc,
			fullPath: context.route.fullPath,
			script: [
				{
					type: 'application/ld+json',
					innerHTML: JSON.stringify({
						'@context': 'https://schema.org',
						'@type': 'Organization',
						'name': 'The Best Agent',
						'image': 'https://tb.co.th/logo.png'
					})
				}
			]
		})
	},

	data:() => ({
		keepAliveActivated: false,
		loading: true,
		query: {},
		page: 1,
		titleTopCommission: null,
		total: 0,
		provinceSelected: null,
		districtSelected: [],
		disabledDistrict: true,
		district: [],
		topAgentList: null,
		agentList: [],
		agentFiredList: [],
		perPage: 20,

		/**
		 * Location AC
		 */
		agentText: '',
		agentQueryText: '',
		agentAcItems: [],
		agentAcLoading: false,
	}),

	computed: {
		...mapGetters({
			location: 'location',
			head: 'page/head',
		}),

		totalPage () {
			return Math.ceil(this.total / 20)
		},

		month () {
			const today = new Date()
			const month = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']

			let lastMonth = today.getMonth() - 1
			let year = today.getFullYear() + 543
			if (lastMonth === -1) {
				lastMonth = 11
				year = year - 1
			}

			return `${month[lastMonth]} ${year}`
		},

		bannerImg () {
			return '/images/2.0/agent-banner.jpg'
		},
	},

	watch: {
		provinceSelected (newVal) {
			if (newVal) {
				this.district = this.provinceSelected.v
				this.disabledDistrict = false
			} else {
				this.disabledDistrict = true
			}
			this.districtSelected = []
		},

		agentText (newVal) {
			this.acQuery(newVal)
		},

		page (newPage) {
			this.$refs.topList.scrollIntoView({ /*behavior: 'smooth',*/ block: 'start' })

			// Need to extract or clone params obj
			let params = { ...this.query }
			params['page'] = newPage

			this.$router.push({
				path: this.$route.path,
				query: params
			})
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
			this.query = this.$route.query
		} else if (this.keepAliveActivated) {
			window.scrollTo(0, 0)
			this.query = this.$route.query
			this.search()
		}
	},

	// In case of search criteria change, just let component react to the new data (no need to re-render component)
	beforeRouteUpdate (to, from, next) {
		if (process.client && from.path === to.path) {
			if (window.windowNavigate) {
				window.windowNavigate = false
				this.query = this.$route.query
			} else {
				// window.scrollTo(0, 0)
				this.query = to.query
				this.search()
			}
			next()

			// Navigate back effect after 'beforeRouteUpdate'
			setTimeout(() => {
				if (window.windowNavigate) {
					window.windowNavigate = false
					this.query = this.$route.query
				}
			}, 1500)
		} else {
			next()
		}
	},

	created() {
		if (process.client) {
			this.query = this.$route.query
			this.initCriteria()
			this.search()
			this.getTopAgent().then(data => {
				this.topAgentList = data.agentList
			})

			this.searchAgent({ fired: 1 }).then(agentObj => {
				this.agentFiredList = agentObj.agentList
			})
		}
	},

	methods: {
		...mapActions({
			getTopAgent: 'agent/getTopAgent',
			searchAgent: 'agent/searchAgent',
			agentQuery: 'agent/agentQuery'
		}),

		initCriteria () {
			if (this.query.agent_id) {
				if (!this.agentQueryText) {
					this.agentQueryText = {}
				}
				this.agentQueryText['agent_id'] = this.query.agent_id
			}
			if (this.query.type) {
				if (!this.agentQueryText) {
					this.agentQueryText = {}
				}
				this.agentQueryText['type'] = this.query.type
			}
			if (this.query.text) {
				if (typeof this.agentQueryText === 'object') {
					this.agentQueryText['name'] = this.query.text
				} else {
					this.agentQueryText = this.query.text
				}
			}

			if (this.query.province) {
				this.provinceSelected = this.location.find(p => p.p.toString() === this.query.province.toString())
				this.query.province = parseInt(this.query.province)
			}
			if (this.query.district) {
				if (typeof this.query.district === 'string') {
					this.query.district = [ parseInt(this.query.district) ]
				} else {
					this.query.district = this.query.district.map(d => parseInt(d))
				}

				// Need to use nextTick
				this.$nextTick(() => {
					this.districtSelected = [ ...this.query.district ]
				})
			}

			if (this.query.page) {
				this.page = parseInt(this.query.page)
			}
		},

		filteredText (search, text) {
			if (text) {
				return text.split(search).join(`<span class="highlight">${search}</span>`)
			}
			return ''
		},

		acQuery (text) {
			this.agentAcItems = []
			if (text && text.length > 2) {
				this.agentAcLoading = true
				this.agentQuery(text).then(list => {
					this.agentAcItems = list
				}).catch(err => {
					console.log(err)
				}).finally(() => {
					this.agentAcLoading = false
				})
			}
		},

		processParamsAndSearch () {
			let params = { ...this.query }

			if (this.agentQueryText.name) {
				params['text'] = this.agentQueryText.name
			} else {
				params['text'] = this.agentText
			}

			if (this.agentQueryText.agent_id) {
				params['agent_id'] = this.agentQueryText.agent_id
			} else {
				delete this.query['agent_id']
				delete params['agent_id']
			}

			if (this.agentQueryText.type) {
				params['type'] = this.agentQueryText.type
			} else {
				delete this.query['type']
				delete params['type']
			}

			if(this.provinceSelected) {
				params['province'] = this.provinceSelected.p
			} else {
				// delete this.query['province']
				delete params['province']
			}

			if(this.districtSelected.length > 0) {
				params['district'] = this.districtSelected
			} else {
				// delete this.query['district']
				delete params['district']
			}

			delete params['page']
			if (!params['text']) {
				delete params['text']
			}

			this.$refs.topList.scrollIntoView({ /*behavior: 'smooth',*/ block: 'start' })
			this.$router.push({
				path: this.$route.path,
				query: params
			}).catch(() => {
				//
			})
		},

		search () {
			this.loading = true
			// this.agentList = []
			// this.total = 0
			// Call to store action for search with query (GET parameter)
			let params = { ...this.query }

			this.searchAgent(params).then(agentObj => {
				this.agentList = agentObj.agentList
				this.total = agentObj.total

				// this.page = parseInt(this.query.page) || 1
				this.loading = false
				this.keepAliveActivated = true
			})
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.bgDarkGrey {
	background-color: #3a3a3a;
}
.v-item--active::v-deep {
	background-color: #3a3a3a !important;
	&::before {
		opacity: 0 !important;
	}
	.v-btn__content, .v-list-item__content {
		color: #fff;
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.agent-of-the-month > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 16%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
</style>
